import * as CONST from 'Reducers/Document/const'

/**
 * Get document types
 *
 * @returns {{type}}
 */
export function getDocumentTypes() {
  return {
    type: CONST.GET_DOCUMENT_TYPES,
  }
}

/**
 * Get document type by id
 *
 * @returns {{type}}
 */
export function getDocumentTypeById(id) {
  return {
    type: CONST.GET_DOCUMENT_TYPE_BY_ID,
    id,
  }
}

/**
 * Update document type by id
 *
 * @param callbacks
 * @param id
 * @param payload
 * @returns {{type, callbacks: *, id: *, payload: *}}
 */
export function updateDocumentTypeById(callbacks, id, payload) {
  return {
    type: CONST.UPDATE_DOCUMENT_TYPE_BY_ID,
    callbacks,
    id,
    payload,
  }
}

/**
 * Create document type
 *
 * @param callbacks
 * @param payload
 * @returns {{type, callbacks: *, payload: *}}
 */
export function createDocumentType(callbacks, payload) {
  return {
    type: CONST.CREATE_DOCUMENT_TYPE,
    callbacks,
    payload,
  }
}

/**
 * Delete document type by id
 *
 * @returns {{type}}
 */
export function deleteDocumentTypeById() {
  return {
    type: CONST.DELETE_DOCUMENT_TYPE_BY_ID,
  }
}
